export default __webpack_public_path__ + "static/media/user-grey.1d8c69e4.svg";